import { Component, OnInit } from '@angular/core';
import { LoopBackConfig, LoopBackAuth } from '../../../../assets/js/lb-sdk';
import { STORAGE_LOCATIONS } from '../../../enums';
import { BasicList } from '../../../classes';
import { TermsAndConditionApi } from '../../../../assets/js/lb-sdk/services/custom/TermsAndCondition';
import { BsModalService } from 'ngx-bootstrap';
import { TermsAndConditionsFormComponent } from './terms-and-conditions-form/terms-and-conditions-form.component';
import { Event } from '../../../interfaces';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.css']
})
export class TermsAndConditionsComponent extends BasicList {
  host:string = LoopBackConfig.getPath();
  container:string = STORAGE_LOCATIONS.TERMS_AND_CONDITIONS;
  searchSettings = {
    searchFields: [],
    searchableFields: [
      { name: 'versionNumber', placeholder: 'Version' }
    ],
    filters: {}
  };

  constructor(
    private termsAndCondtionApi: TermsAndConditionApi,
    private modalService: BsModalService,
    private loopBackAuth: LoopBackAuth,
    private toast: ToastrService
  ) {
    super();
    this.searchSettings.searchFields.push(this.searchSettings.searchableFields[0]);
    this.params = {
      where: {
        partnerId: this.getUser().partnerId
      },
      order: 'uploadDate DESC'
    };
    this.settings = {
      createComponent: TermsAndConditionsFormComponent,
      api: this.termsAndCondtionApi,
      ModalService: this.modalService
    };
  }

  getUser() {
    return this.loopBackAuth.getToken() ? this.loopBackAuth.getCurrentUserData() : undefined;
  }

  eventListener(event: Event) {
    switch (event.event) {
      case 'createModal:completed':
        this.toast.success('New Terms and Conditions successfully uploaded', 'Terms and Conditions');
        this.getList();
        break;
      case 'editModal:completed':
        this.toast.success('Terms and Conditions successfully updated', 'Terms and Conditions');
        this.getList();
        break;
      case 'delete:success':
        this.toast.success('Terms and Conditions successfully deleted', 'Terms and Conditions');
        this.getList();
        break;
      case 'initialized':
        this.getList();
        break;
    }
  }
}
